import ToDoList from './ToDoList';
import Pomodoro from './Pomodoro';
import './App.css';

function App() {
  return (
    <div className="app">
      <ToDoList/>
      <Pomodoro/>
    </div>
  );
}

export default App;
